<div #ordertypebar id="ordertypebar" *ngIf="!siteClose">
    <div class="start-order-module" *ngIf="orderTypes.length>0">
        <div class="orderTypes" [class.promo3]="discount>0">
            <div class="promo2" *ngIf="discount>0">
                <div class="d-flex">
                    <img src="assets/images/megaphone.svg" alt="promo" width="30px">
                    <p class="text-center">
                        Réduction<b> {{discount}} %</b> à partir de <b>{{discountFrom}} €</b> d'achats
                    </p>
                </div>
            </div>
            <button *ngFor="let type of orderTypes;let i=index" (click)="changeMode(type.id)"
                [class.active]="chosenOrderType==type.id" class="button" [class.delivery]="type.id==1"
                [class.pickup]="type.id==3" [class.onspot]="type.id==2">
                <img src="assets/images/{{type.id}}.png" alt="{{type.label}}" title="{{type.label}}">
                <span>{{type.label}}</span>
            </button>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row" id="carte">
        <div class="col-md-12">
            <div class="title">
                <h1>
                    <strong>La Carte</strong>
                </h1>
            </div>
        </div>
    </div>
    <div class="carte" id="card" [class.hidebasket]="siteClose">
        <div class="cat">
            <div>
                <div class="categories" sticky [header]='header' [activeTab]="loadSticky">
                    <ul class="nav menu-head">
                        <li class="title" [ngClass]="{active:(activeTab==1 && menucategories.length>3)}"
                            (click)="setActiveTab(1)">
                            Produits
                        </li>
                        <li class="title" *ngIf="menucategories.length>3" [ngClass]="{active:activeTab==2}"
                            (click)="setActiveTab(2)">
                            Menus
                        </li>
                    </ul>
                    <ul class="nav menu-left-list" *ngIf="activeTab==1">
                        <ng-container *ngIf="menucategories.length<=3">
                            <li *ngFor="let menucategory of menucategories;let i=index"
                                [ngClass]="{active:menuCategoryActive==i,'menucategory':i==0}" (click)="getMenus(i);">
                                <a class="scrollTo" disableLink
                                    href="/carte/menu/{{menucategory.slug}}">{{menucategory.name}}</a>
                            </li>
                        </ng-container>
                        <li *ngFor="let family of families;let i=index" [ngClass]="{active:familyActive==i}"
                            (click)="getProducts(i);">
                            <a class="scrollTo" disableLink href="/carte/famille/{{family.slug}}">
                                <span>{{family.label}}</span>
                            </a>
                        </li>
                    </ul>
                    <ul class="nav menu-left-list" *ngIf="activeTab==2 && menucategories.length>3">
                        <li *ngFor="let menucategory of menucategories;let i=index"
                            [ngClass]="{active:menuCategoryActive==i,'menucategory':i==0}" (click)="getMenus(i);">
                            <a class="scrollTo" disableLink
                                href="/carte/menu/{{menucategory.slug}}">{{menucategory.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="cartefamilies elements">
            <div class="container-fluid">
                <div class="row carte-search">
                    <div class="col-md-6">
                        <i class="flaticon-magnifying-glass-icon"></i>
                        <input aria-label="Recherche produit" type="text" name="searchElement"
                            placeholder="Tapez le nom du produit..." [(ngModel)]="searchElement"
                            (keyup)="searchForElement()" class="form-control">
                    </div>
                    <div class="col-md-6">
                        <i class="flaticon-magnifying-glass-icon"></i>
                        <ng-select [items]="compositions" [multiple]="true" bindLabel="text" bindValue="id"
                            placeholder="Tapez l'ingrédient désiré..." [(ngModel)]="selectedComp"
                            (change)="changedCompositions()">
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-sm-12 carte-products">
                        <div class="col-container" *ngIf="!loading && familyActive>-2">
                            <div *ngFor="let product of products;let i=index" class="item">
                                <product (OnPersonalize)="PersonalizeModal(i)" (OnAdd)="addElementToBasket(i)"
                                    [product]="product"></product>
                            </div>
                        </div>
                        <div class="alert alert-danger text-center"
                            *ngIf="!loading && familyActive>-2 && products.length==0 && menuCategoryActive>-2 && menus.length==0">
                            Produit non disponible
                            <ng-container *ngIf="chosenOrderType==1">en livraison</ng-container>
                            <ng-container *ngIf="chosenOrderType==3">à emporter</ng-container>
                            <ng-container *ngIf="chosenOrderType==2">sur place</ng-container>
                        </div>
                        <div class="col-container" *ngIf="!loading && menuCategoryActive>-2">
                            <div *ngFor="let menu of menus;let i=index" class="item">
                                <menu-card (OnAdd)="OpenMenuModal(i)" [menu]="menu">
                                </menu-card>
                            </div>
                        </div>
                        <div *ngIf="loading" id="loadingPage"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panier" *ngIf="!siteClose">
            <app-panier [showButton]="true" [header]="header"></app-panier>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
        <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <button type="button" class="btn btn-default mr-10" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
    </div>
</ng-template>